// extracted by mini-css-extract-plugin
export default {"loader_container":"brand_loading_loader_container__AqDd5","loader_image":"brand_loading_loader_image__AG926"};